import { handleCleanObjFromFalsyValues } from 'app/utils/helpers';
import { getSearchState } from 'app/utils/search-state';
import { TObj } from 'app/utils/types';
import { useState, useCallback } from 'react';
import useBrowserBack from './use-browser-back';

/**
 * useFilters custom hook that returns filters and some functions that helps you to handle filters
 */
const useFilters = (initialFilters: TObj): TObj => {
  const [initialCleanedFilters] = useState(() =>
    handleCleanObjFromFalsyValues(initialFilters),
  );
  const [filters, setFilters] = useState(() => initialCleanedFilters);
  const [formattedFilters, setFormattedFilters] = useState<any>(null);
  const onChangeFilter = useCallback(
    (name: string) => (option: any, newName?: string) => {
      setFilters((old) => ({ ...old, [newName || name]: option }));
    },
    [],
  );
  const resetFilters = (): TObj => {
    const excludeKeys = [
      'group_id',
      'category_id',
      'type_of_sort',
      'order_column',
      'parent_id',
      'module_name',
      'sub_module_name',
      'set_id',
      'template_id',
      'item_ids',
    ];

    const keys = Object.keys(initialFilters);
    const resetFiltersObj: any = {};

    keys.forEach((item: any) => {
      if (!excludeKeys.some((i) => i === item))
        resetFiltersObj[item] =
          typeof initialFilters[item] === 'string' &&item!=='source_url' && item!=='name' ? '' : null;
      else resetFiltersObj[item] = initialFilters[item];
    });
    setFilters(resetFiltersObj);
    return resetFiltersObj;
  };

  const formatFilters = () => {
    const formattedFilters: TObj = {};
    Object.keys(filters).map((input: any) => {
      if (filters[input]) {
        if (Array.isArray(filters[input])) {
          const values = filters[input].map((item: any) => {
            return item?.value > -1 || typeof item?.value === 'boolean'
              ? item?.useLabel
                ? item?.label
                : item?.value
              : item;
          });
          formattedFilters[input] = values;
        } else {
          if (
            typeof filters[input] === 'string' ||
            typeof filters[input] === 'number' ||
            !filters[input]?.value
          ) {
            formattedFilters[input] = filters[input];
          } else {
            formattedFilters[input] = filters[input]?.value;
          }
        }
      }
    });
    setFormattedFilters(formattedFilters);

    return formattedFilters;
  };
  useBrowserBack({
    onBrowserHistoryChange: () => {
      resetFilters();
      setFilters(handleCleanObjFromFalsyValues(getSearchState()?.filters));
    },
  });

  const handleGetDates = {
    end_date: filters?.end_date ? filters?.end_date : new Date(),
    start_date: filters?.start_date ? filters?.start_date : new Date(),
  };

  return {
    filters,
    onChangeFilter,
    resetFilters,
    formatFilters,
    formattedFilters,
    handleGetDates,
  };
};

export default useFilters;
